import './page-not-found.scss';
import * as pageNotFoundController from './page-not-found.controller';

const pageNotFoundState = {
  name: 'not-found',
  url: '/not-found?reason&detail',
  template: require('./page-not-found.jade'),
  controller: 'PageNotFoundController',
  controllerAs: 'vm'
};

export default angular.module('gazelle.components.pageNotFound', [
  'ui.router'
])
  .controller(pageNotFoundController.name, pageNotFoundController.default)
  .constant('gzPageNotFoundState', pageNotFoundState)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/page-not-found/page-not-found.module.js